"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HashTagsFooterCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const web_sds_c_1 = require("@snapchat/web-sds-c");
const HashtagsFooterCard_module_css_1 = __importDefault(require("./HashtagsFooterCard.module.css"));
function hashtag({ hashtag }) {
    return ((0, jsx_runtime_1.jsx)("div", { className: HashtagsFooterCard_module_css_1.default.hashtag, children: (0, jsx_runtime_1.jsx)(web_sds_c_1.Heading, { size: "H7", children: (0, jsx_runtime_1.jsx)("span", { className: HashtagsFooterCard_module_css_1.default.hashtagText, children: hashtag }) }) }, hashtag));
}
/**
 *
 */
function HashTagsFooterCard({ hashTags, isMobile }) {
    return ((0, jsx_runtime_1.jsx)("div", { className: `${HashtagsFooterCard_module_css_1.default.hashTagContainer} ${isMobile ? HashtagsFooterCard_module_css_1.default.hashTagContainerMobile : HashtagsFooterCard_module_css_1.default.hashTagContainerDesktop}`, children: hashTags.map((tag) => hashtag({
            hashtag: tag,
        })) }));
}
exports.HashTagsFooterCard = HashTagsFooterCard;
//# sourceMappingURL=HashTagsFooterCard.js.map